/**
 * Checks if a search term matches any of the date parts of a given date.
 * @param {string|Date} dateValue - The date to check against.
 * @param {string} searchTerm - The lowercased search term.
 * @returns {boolean} - True if the search term matches a date part.
 */
export const matchDate = (dateValue, searchTerm) => {
    if (!dateValue || !searchTerm) return false;

    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return false;

    const lowerSearch = searchTerm.toLowerCase();

    // Standard date string (e.g., "MM/DD/YYYY" or locale specific)
    const dateString = date.toLocaleDateString().toLowerCase();
    if (dateString.includes(lowerSearch)) return true;

    // Month names
    const monthShort = date.toLocaleDateString(undefined, { month: 'short' }).toLowerCase();
    const monthLong = date.toLocaleDateString(undefined, { month: 'long' }).toLowerCase();
    if (monthShort.includes(lowerSearch) || monthLong.includes(lowerSearch)) return true;

    // Specific day or year
    const day = date.getDate().toString();
    const year = date.getFullYear().toString();
    if (day === lowerSearch || year.includes(lowerSearch)) return true;

    return false;
};

/**
 * Higher-order filter function for orders.
 * @param {Array} orders - List of orders.
 * @param {string} searchTerm - The search string.
 * @returns {Array} - Filtered list of orders.
 */
export const filterOrders = (orders, searchTerm) => {
    if (!searchTerm) return orders;

    const lowerSearch = searchTerm.toLowerCase();

    return orders.filter((order) => {
        // ID search (full or slice)
        const matchesId = order._id.toLowerCase().includes(lowerSearch);

        // Customer name search
        const firstName = order.customerDetails?.firstName?.toLowerCase() || "";
        const lastName = order.customerDetails?.lastName?.toLowerCase() || "";
        const matchesName = firstName.includes(lowerSearch) || lastName.includes(lowerSearch);

        // Date search
        const matchesDateValue = matchDate(order.createdAt, lowerSearch);

        return matchesId || matchesName || matchesDateValue;
    });
};
